<template>
  <div :class="macAddress.split('.')[0]">
    <div class="group-title d-flex align-items-center" :class="{ bordered: isShowing }" @click="toggleShow">
      <span class="flex-grow-1">{{ type }}</span>
      <i class="icon icon-arrow-top" v-if="isShowing"></i>
      <i class="icon icon-arrow-bottom" v-if="!isShowing"></i>
    </div>

    <transition name="expand">
      <div class="free-wagers" v-if="isShowing">
        <div
          v-for="free in freeWager"
          :key="free.id"
          class="p-2 free-wager-title d-flex align-items-center"
          :class="{ selected: isSameWager(free.free_wager) }"
          @click="
            $emit('freeWagerClick', {
              freeWager: free.free_wager,
              freeWagerPrizeId: free.id,
            })
          "
        >
          <span class="flex-grow-1">{{ free.free_wager.name }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { toggle } from '@/utils/mixins/toggle';
import { mapState } from 'vuex';

export default {
  props: ['type', 'freeWager'],
  mixins: [toggle],
  computed: {
    ...mapState({
      freeWagersViewing: state => state.freeWagerStore.freeWagersViewing,
      selectedFreeWager: state => state.freeWagerStore.selectedFreeWager,
      macAddress: state => state.settings.macAddress,
    }),
  },
  created() {
    this.isShowing = false;
  },
  methods: {
    isSameWager(freeWager) {
      return this.freeWagersViewing && this.selectedFreeWager.id === freeWager.id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins/_mixins';

.apueston {
  $secondary-button: #5bb3ff;
  .group-title {
    color: var(--color3);
  }
  .free-wager-title.selected {
    color: var(--color3);
  }
}

.group-title {
  text-transform: capitalize;
  font-weight: 700;
  padding: 7px 12px;
  font-size: 13px;
  cursor: pointer;
  overflow: hidden;

  @media (max-width: 767px) {
    padding: 4px 10px;
    font-size: 12px;
  }

  &.bordered {
    border-bottom: 1px solid #ececec;
  }
}
.free-wager-title {
  color: #323a49;
  font-weight: 700;
  padding: 7px 12px;
  font-size: 13px;
  transition: 0.3s ease all;
  cursor: pointer;

  @media (max-width: 767px) {
    font-size: 11px;
    font-weight: 700;
  }

  &:hover {
    background-color: #ececec;
  }
  &.selected {
    color: var(--color3);
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: opacity 0.2s;
}
.expand-enter,
.expand-leave-to {
  opacity: 0;
}
</style>
